export default __webpack_public_path__ + "images/google2.png";